import * as yup from 'yup';

export interface IResetPassword {
	email: string;
	password: string;
	passwordConfirm: string;
}

export const resetPasswordInitialValues: IResetPassword = {
	email: '',
	password: '',
	passwordConfirm: '',
};

export const resetPasswordSchema = yup.object().shape({
	email: yup.string().email().required('required'),
	password: yup.string().required('required'),
	passwordConfirm: yup
		.string()
		.oneOf([yup.ref('password')], 'passwordConfirmError')
		.required('required'),
});
